<template>
    <!-- Personalised vitamins are mixed from the full Wellbeing test's results: in place of buying
         them, Wellbeing to add, or its results to wait for -->
    <UpgradePrompt v-if="purchased" icon="clock"
        title="Personalised vitamins are available once your Wellbeing results are in">
        We mix them from those results, so you can order them as soon as they're ready.
    </UpgradePrompt>
    <UpgradePrompt v-else title="Personalised vitamins are mixed from your Wellbeing results"
        action="Explore Wellbeing" :to="{ name: 'AncestryDetails', params: { slug: 'Wellbeing-Upgrade' } }">
        Add Wellbeing<template v-if="profileName"> to <strong>{{ profileName }}</strong>'s profile</template>, and once
        its results are in we'll blend vitamins for your DNA.
    </UpgradePrompt>
</template>

<script setup>
import { computed } from "vue";
import store from "@/store";
import UpgradePrompt from "@/components/store/UpgradePrompt.vue";
import { useWellbeingResults } from "@/composables/useWellbeingResults";

const { purchased } = useWellbeingResults();
const profileName = computed(() => store.getters.profile?.profile?.name);
</script>
